<template>
  <div class="groups-header">
    <div class="groups-header__checkbox">
      <DataCheckbox
      v-model="allGroupsChecked" />
    </div>
    <div
    v-for="header in getHeadersList"
    :key="header.id"
    :style="{
      order: getOrder(header.value),
      width: header.width + 'px' || ''
    }"
    class="groups-header__element"
    :class="header.value === 'name' && 'groups-header__element_name'">
      <div
      v-if="getSelectedTypeOfGroups === 'mave' ? Array.isArray(header.valueMave) : Array.isArray(header.value)"
      class="groups-header__element_double">
        <div
        class="groups-header__element_double"
        @click="changeSort(getSelectedTypeOfGroups === 'mave' ? header.sortMave[0] : header.sort[0] )">
          <span
          v-tooltip="!header.sort ? `${$t('Sorting by this field is not available')}` : ''"
          class="groups-header__text"
          :class="[
            header.sort[0] === getGroupsSortBy && 'groups-header__text_selected',
            header.sort[0] && 'pointer'
          ]">
            {{ getSelectedTypeOfGroups === 'mave' && header.valueMave[0] ? $t(header.valueMave[0]) : $t(header.value[0]) }}
          </span>
          <DataIcon
          :size="12"
          name="south"
          :arrow-open="getGroupsSortDir === 'asc' && header.sort[0] === getGroupsSortBy"
          class="groups-header__icon"
          :class="[
            header.sort[0] === getGroupsSortBy && 'groups-header__icon_selected',
            header.sort[0] && 'pointer'
          ]" />
        </div>
        <span class="groups-header__text">/</span>
        <div
        class="groups-header__element_double"
        @click="changeSort(getSelectedTypeOfGroups === 'mave' && header.valueMave[1] ? header.sortMave[1] : header.sort[1] )">
          <span
          v-tooltip="!header.sort ? `${$t('Sorting by this field is not available')}` : ''"
          class="groups-header__text"
          :class="[
            header.sort[1] === getGroupsSortBy && 'groups-header__text_selected',
            header.sort[1] && 'pointer'
          ]">
            {{ $t(header.value[1]) }}
          </span>
          <DataIcon
          :size="12"
          name="south"
          :arrow-open="getGroupsSortDir === 'asc' && header.sort[1] === getGroupsSortBy"
          class="groups-header__icon"
          :class="[
            header.sort[1] === getGroupsSortBy && 'groups-header__icon_selected',
            header.sort[1] && 'pointer'
          ]" />
        </div>
      </div>

      <div
      v-else
      class="groups-header__element_double"
      @click="changeSort(header.sort)">
        <span
        v-tooltip="!header.sort ? `${$t('Sorting by this field is not available')}` : ''"
        class="groups-header__text"
        :class="[
          header.sort === getGroupsSortBy && 'groups-header__text_selected',
          header.sort && 'pointer'
        ]">
          {{ getSelectedTypeOfGroups === 'mave' && header.valueMave ? $t(header.valueMave) : $t(header.value) }}
        </span>
        <DataIcon
        v-if="header.info"
        v-tooltip="`${$t(header.info)}`"
        :size="14"
        name="info_outline"
        class="groups-header__text"
        :class="header.sort === getGroupsSortBy && 'groups-header__text_selected'" />
        <DataIcon
        :size="12"
        name="south"
        :arrow-open="getGroupsSortDir === 'asc' && header.sort === getGroupsSortBy"
        class="groups-header__icon"
        :class="[
          header.sort === getGroupsSortBy && 'groups-header__icon_selected',
          header.sort && 'pointer'
        ]" />
      </div>

      <div
      v-if="header.value === 'description'"
      v-tooltip.right="getAiTooltip"
      class="groups-header__description-ai"
      :class="getSelectedDescription === 'ai' && 'groups-header__description-ai_active'"
      @click="changeSelecedDescription">
        <span class="groups-header__description-ai-text">
          Ai
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupsHeaders',
  props: {
    selectedType: {
      type: String,
      default: null,
    },
    mode: {
      type: String,
      default: null,
    },
    isHiddenMode: {
      type: [Boolean, String],
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    // Параметр менеджера у пользователя
    isManager: {
      type: Boolean,
      default: false,
    },
    selectedGroups: {
      type: Array,
      default: null,
    },
    columns: {
      type: Array,
      default: null,
    },
    isCompilation: {
      type: Boolean,
      default: false,
    },
    isAllSelected: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    const selectedDescriptionType = localStorage.getItem('selectedDescriptionType');
    if (selectedDescriptionType) {
      this.$store.commit('catalog/setSelectedDescription', selectedDescriptionType);
    }
  },
  methods: {
    changeSort(value) {
      if (!value) {
        return;
      }
      if (this.getSelectedTypeOfGroups === 'mave') {
        return;
      }
      if (this.isCompilation) {
        if (this.getGroupsSortBy === value) {
          const newDir = this.getGroupsSortDir === 'asc' ? 'desc' : 'asc';
          this.$store.commit('compilations/setSortDir', newDir);
        } else {
          this.$store.commit('compilations/setSortDir', 'desc');
        }
        this.$store.commit('compilations/setSortBy', value);
        const compilationId = this.getCompilationInfo.id;
        this.$store.commit('compilations/setIsLoadingCompilation', true);
        this.$store.dispatch('compilations/getCurrentCompilationGroups', { id: compilationId, reset: true })
          .finally(() => { this.$store.commit('compilations/setIsLoadingCompilation', false); });
        this.$store.dispatch('compilations/getCurrentCompilationInfo', { id: compilationId });
        this.$store.dispatch('compilations/getCurrentCompilationSummary', { id: compilationId });
      } else {
        if (this.getGroupsSortBy === value) {
          const newDir = this.getGroupsSortDir === 'asc' ? 'desc' : 'asc';
          this.$store.commit('groups/setSortDir', newDir);
        } else {
          this.$store.commit('groups/setSortDir', 'desc');
        }

        this.$store.commit('groups/setSortBy', value);

        this.$store.commit('groups/setLoadPage', 1);
        this.$store.commit('groups/setGroupsData', []);
        this.$store.dispatch('groups/loadGroupsData');
      }
    },
    getOrder(element) {
      return this.columns.findIndex((item) => item.value === element);
    },
    changeSelecedDescription() {
      const newSelectedDescription = this.getSelectedDescription === 'ai' ? 'description' : 'ai';
      localStorage.setItem('selectedDescriptionType', newSelectedDescription);
      this.$store.commit('catalog/setSelectedDescription', newSelectedDescription);
    },
  },
  computed: {
    allGroupsChecked: {
      get() {
        return this.isAllSelected;
      },
      set(value) {
        this.$emit('clickCheckbox', value);
      },
    },
    getHeadersList() {
      try {
        let list;
        if (this.isAdmin) {
          list = this.columns.filter((header) => header.show);
        } else if (this.isAgency) {
          list = this.columns.filter((header) => (!header.admin || header.agency) && header.show);
        } else {
          list = this.columns.filter((header) => !header.admin && header.show);
        }

        const filteredList = this.isCompilation
          ? list
          : list.filter((item) => item.value !== 'bot-notify' && item.value !== 'margin' && item.value !== 'responsible' && item.value !== 'note');

        return !this.isHiddenMode ? filteredList.filter((item) => item.value !== 'bad_reason') : filteredList;
      } catch {
        const list = this.columns.filter((header) => !header.admin && header.show);
        const filteredList = this.isCompilation
          ? list
          : list.filter((item) => item.value !== 'bot-notify' && item.value !== 'margin' && item.value !== 'responsible' && item.value !== 'note');

        return !this.isHiddenMode ? filteredList.filter((item) => item.value !== 'bad_reason') : filteredList;
      }
    },
    getGroupsSortBy() {
      return this.isCompilation
        ? this.$store.getters['compilations/getGroupsSortBy']
        : this.$store.getters['groups/getGroupsSortBy'];
    },
    getGroupsSortDir() {
      return this.isCompilation
        ? this.$store.getters['compilations/getGroupsSortDir']
        : this.$store.getters['groups/getGroupsSortDir'];
    },
    isAgency() {
      return this.$store.getters['user/getIsAgency'];
    },
    getCompilationInfo() {
      return this.$store.getters['compilations/getCurrentCompilationInfo'];
    },
    getAiTooltip() {
      if (this.getSelectedDescription === 'ai') {
        return 'Нажмите, чтобы увидеть обычное описание каналов';
      }
      return 'Нажмите, чтобы увидеть описание от нейросети';
    },
    getSelectedDescription() {
      return this.$store.getters['catalog/getSelectedDescription'];
    },
    getSelectedTypeOfGroups() {
      return this.$store.getters['groups/getSelectedTypeOfGroups'];
    },
  },
};
</script>

<style lang="scss" scoped>
.groups-header {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 4;
  background: white;
  display: flex;
  align-items: center;
  border-top: 1px solid $primary-group-border;
  border-bottom: 1px solid $primary-group-border;
  min-width: 100%;
}

.groups-header__checkbox {
  position: sticky;
  background: white;
  top: 0px;
  left: 0px;
  padding-left: 30px;
  z-index: 2;
  height: 20px;
  width: 40px;
  @include tablet-screen {
    width: 124px;
  }
}

.groups-header__elements {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.groups-header__element_double {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  @include between-elements {
    margin-right: 5px;
  }
}

.groups-header__element {
  width: 180px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  height: 48px;
  position: relative;
  &_name {
    position: sticky;
    left: 40px;
    width: 160px;
    padding-left: 10px;
    justify-content: flex-start;
    top: 0px;
    text-align: left;
    z-index: 1;
    background: white;
    @include tablet-screen {
      left: 124px;
      padding-left: 0px;
      width: 295px;
    }
  }
}

.groups-header__text {
  color: $primary-lightgray;
  font-size: 13px;
  &_selected {
    color: $primary-gray;
    font-weight: 600;
  }
}

.groups-header__icon {
  color: $primary-lightgray;
  &_selected {
    color: $primary-gray;
  }
}

.groups-header__description-ai {
  position: absolute;
  top: 14px;
  right: 55px;
  background: rgb(165, 165, 165);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  color: white;
  font-size: 10px;
  cursor: pointer;
  transition: 0.2s;
  &_active {
    background: rgba($primary-blue, 0.8);
  }
}

.groups-header__description-ai-text {
  pointer-events: none;
}

</style>
